<template>
  <div class="row-content">
    <div class="row-title">
      <span>{{title}}</span>
    </div>
    <div class="data-wrapper">
      <div class="echart-class-status" id="echart-pie-women"></div>
    </div>
  </div>
</template>

<script>
  import echarts from "echarts";
  import {debounce} from "@/assets/js/utils";
  import storage from "@/utils/storage";

  export default {
    props:{
      statisticsSquadLevel:{},
      schoolComplete:{},
      title: {
        type: String,
        required: true,
        default: "统计",
      },
      propsReloadTime:{
        type:Number,
        required:false,
        default:30000
      }
    },

    data(){
      return {
        loading:false,
        mapObj:null,
        pieDatakey:0,
        youthList:[], // 精英机构列表
        squadList:[], // 精英机构球队列表
        completeList:[], // 精英机构球队列表
        isComplete:0,
        selectYouthIndex:0, // 精英机构球队统计默认精英机构选择
        youthAutoChangeTimer:null, // 精英机构默认切换
        changeTimer:null,
        userRole:storage.get("userInfo").userRole,
      };
    },

    computed:{
      echartsPieOptions(){
        let option = {
          tooltip:{
            trigger:"item",
          },
          legend:{
            bottom:10,
            left:"left",
            textStyle:{
              color:"#61A8FF",
            },
          },
          series:[
            {
              name:"",
              type:"pie",
              radius:"70%",
              bottom:"12%",
              center:["50%", "50%"],
              data:[], // 数据
              label:{
                formatter:"{b}： {c}",
                position:"top",
                show:true,
                fontSize: 16 // 这里设置文字大小
              },
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 0,
                normal: {
                  color: function(params) {
                    // 根据数据索引返回不同的颜色 红橙黄绿青蓝
                    var colorList = [ '#ff8b20','#27ca79', '#33a4fd'];
                    return colorList[params.dataIndex];
                  }
                }
              },
              emphasis:{
                itemStyle:{
                  shadowBlur:10,
                  shadowOffsetX:0,
                  shadowColor:"rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        return option;
      },
    },
    watch:{
      // 监测协会列表显示内容
      'selectYouthIndex':function(){
        this.drawClassStatus();
      }
    },

    mounted(){
      this.loadData(); // 加载数据
//      this.autoChangeSelectYouthIndex(); // 自动变动
      this.drawClassStatus(); // 绘制饼状图

      if(this.mapObj){
        window.onresize = debounce(
          function(){
            this.mapObj.resize();
          },
          100,
          false
        );
      }
    },

    destroyed(){
      clearInterval(this.youthAutoChangeTimer);
    },

    methods:{
      loadData(){
        this.squadList = this.statisticsSquadLevel;
      },

      // 切换显示当前精英机构数据 selectYouthIndex   youthAutoChangeTimer
//      autoChangeSelectYouthIndex(){
//        if(this.youthAutoChangeTimer) clearInterval(this.youthAutoChangeTimer);
//        this.youthAutoChangeTimer = setInterval(() => {
//          this.selectYouthIndex = this.selectYouthIndex + 1;
//        }, 4000)
//      },

      // 绘制会员协会培训班统计表
      drawClassStatus(){
        // 设置图例
        const {series} = this.echartsPieOptions;
        const sourceSeries = series[0];
        sourceSeries.data = this.squadList; // 获取data数据
        let color = [
          '#68D8FE', '#FAC858', '#EE6666'
        ];
        const options = Object.assign({}, this.echartsPieOptions, {
          series:[sourceSeries],
          color
        });

        // 开始画图
        const mapDom = document.getElementById("echart-pie-women");
        let class_status = echarts.init(mapDom);
        class_status.setOption(options);
        this.mapObj = class_status;
      },

      // 球队数据转化pie饼图数据
      formateSquadDataPieData(){
        const selectYouthIndex = this.selectYouthIndex;
        if(selectYouthIndex >= this.youthList.length){
          this.selectYouthIndex = 0;
        }
        // 获取球队列表中的一个
        return this.squadList[this.selectYouthIndex];
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .row-content
    padding 1.25rem 0

    .row-title
      color #68D8FE
      font-weight 600
      font-size 16px
      margin-bottom 0.4rem
      display flex
      align-items center

    .data-wrapper
      display flex
      flex-wrap wrap
      position: relative;
      .echart-class-status
        height 290px
        width 100%
      .child
        position: absolute; /* 设置为 absolute 进行绝对定位 */
        color: #ffbd57;
        bottom: 15px;
        right: 50px;
</style>
